import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

const componentName = 'wok-notification';

export default <FunctionalComponentOptions>{
    name: componentName,
    
    functional: true,

    props: {
        icon: {
            type: String,
            default: undefined
        },
        kind: {
            type: String,
            default: 'info',
            validator: (v: string) => v == '' || /(info|danger|success|warning)/.test(v)
        },
        size: {
            type: String,
            default: 'default',
            validator: (v: string) => v == '' || /(default|compact)/.test(v)
        },
        show: {
            type: Boolean,
            default: false
        },
        canHide: {
            type: Boolean,
            default: false
        }
    },

    render: function(h: CreateElement, ctx: RenderContext) {
        const onHideClick = ctx.listeners['hide-request'] || [];
        
        return h(
            'transition', { props: { name: 'fade' }}, [
                ctx.props.show && h('div', {
                    class: [
                        'wok--notification__wrapper',
                        `wok--notification--${ctx.props.kind}`,
                        `wok--notification--${ctx.props.size}`, 
                        ctx.data.staticClass
                    ],
                    attrs: { 'data-message': ctx.data.attrs && ctx.data.attrs['data-message'] }
                }, [
                    appropriateIcon(ctx) && h('i', { class: 'wok--notification__icon' }, [
                        h(appropriateIcon(ctx))
                    ]),
                    h('div', { class: 'wok--notification__text' }, [
                        ctx.slots().title && h('p', { class: 'wok--notification__title wok--heading-06' }, [
                            ctx.slots().title
                        ]),
                        ctx.slots().subtitle && h('p', { class: 'wok--notification__subtitle wok--body-short-01' }, [
                            ctx.slots().subtitle
                        ])
                    ]),
                    ctx.props.canHide && h('button', { 
                        class: 'wok--notification__hide',
                        attrs: { type: 'button' },
                        on: { click: onHideClick }
                    }, [
                        h('i', { class: 'wok--notification__hide-icon' }, [
                            h('wok-icon-close-sm-16')
                        ])
                    ])
                ])
            ]
        )
    }
}

function appropriateIcon(ctx: RenderContext) {
    if (ctx.props.icon) {
        return ctx.props.icon;
    }
    if (ctx.props.kind == 'success') {
        return 'wok-icon-check-c-16';
    }
    if (ctx.props.kind == 'warning') {
        return 'wok-icon-warning-c-16';
    }
    if (ctx.props.kind == 'danger') {
        return 'wok-icon-warning-c-16';
    }
    return undefined;
}